<div #gameplaycontainer class="gameplay__player">
  <span #reactgameplay></span>
</div>
